export const CategoryInfos = [
    {
        title: "Electronics",
        name: "electronics",
        imgLink: "https://fakestoreapi.com/img/81Zt42ioCgL._AC_SX679_.jpg",
    },
    {
        title: "Women's Clothing",
        name: "women's clothing",
        imgLink: "https://fakestoreapi.com/img/61pHAEJ4NML._AC_UX679_.jpg",
    },
    {
        title: "Men's Clothing",
        name: "men's clothing",
        imgLink: "https://fakestoreapi.com/img/71li-ujtlUL._AC_UX679_.jpg",
    }, 
    {
        title: "Jewelry",
        name: "jewelry",
        imgLink: "https://m.media-amazon.com/images/I/71r7eWuCsaL._AC_UL480_FMwebp_QL65_.jpg",
    },
]